import { useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { signIn } from '../../redux/slices/authSlice';
import { saveTokens } from '../../utils/auth';

export default function GoogleLoginPage() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const getData = useCallback(
        async (data) => {
            try {
                const response = await dispatch(signIn(data)).unwrap();
                saveTokens(response.data);
                navigate('/dashboard');
            } catch (error) {
                navigate('/');
            }
        },
        [dispatch, navigate],
    );

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');
        const data = { code, provider: 'GOOGLE' };

        getData(data);
    }, [getData]);

    return <></>;
}
